export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/569373b84d4fa61cda98164451d2ed57.svg";